module.exports = __webpack_public_path__ + "static/media/Lato-BlackItalic.16d065a7.eot";